import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {

  title: string;
  message: string;
  type: 'default' | 'warning';
  confirm?: string;
  cancel?: string;

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
      title: string,
      message: string,
      type: 'default' | 'warning',
      confirm?: string,
      cancel?: string
    },
  ) {

    this.title = data.title;
    this.message = data.message;
    this.confirm = data.confirm;
    this.cancel = data.cancel;
    this.type = data.type;
  }

  cancelAction() {
    return this.dialogRef.close(false);
  }

  confirmAction() {
    this.dialogRef.close(true);
  }

  isDefault() {
    return this.type === 'default';
  }

  isWarning() {
    return this.type === 'warning';
  }

}
